import { FC } from "react"

import { buildCssClassName } from "@/3514/utils"

import "./styles.scss"

interface IProps {
    className?: string
    variant?: "secondary" | "accent"
    size?: "small" | "normal"
    width?: number | string
    height?: number | string
}

const Spinner: FC<IProps> = ({ className, width = "2rem", height = "2rem", variant = "", size = "normal" }) => {
    return (
        <div
            className={buildCssClassName("spinner-border spinner-wiser", {
                [className]: className,
                sm: size === "small",
                [variant]: variant
            })}
            role="status"
            style={{ width, height }}
        >
            <span className="sr-only">Loading...</span>
        </div>
    )
}

export default Spinner
